<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <q-page class="flex flex-center bg-gradient">
        <div class="login-container">
          <!-- Logo e Título -->
          <div class="text-center q-mb-xl">
            <q-icon size="110px">
              <img src="../assets/icon2.png" alt="">
            </q-icon>
            <h4 class="text-h4 text-weight-bold q-mb-sm q-mt-none">Bem-vindo de volta</h4>
            <p class="text-grey-7">Faça login para acessar sua conta</p>
          </div>

          <!-- Card de Login -->
          <q-card class="login-card q-pa-lg shadow-10">
            <q-card-section>
              <q-form @submit="handleLogin" class="q-gutter-md">
                <!-- Campo Email -->
                <q-input
                  v-model="form.email"
                  type="email"
                  label="Email"
                  outlined
                  :rules="[
                    val => !!val || 'Email é obrigatório',
                    val => /.+@.+\..+/.test(val) || 'Email inválido'
                  ]"
                  lazy-rules
                  :error="!!errors.email"
                  :error-message="errors.email"
                >
                  <template v-slot:prepend>
                    <q-icon name="mail" />
                  </template>
                </q-input>

                <!-- Campo Senha -->
                <q-input
                  v-model="form.password"
                  :type="showPassword ? 'text' : 'password'"
                  label="Senha"
                  outlined
                  :rules="[
                    val => !!val || 'Senha é obrigatória',
                    val => val.length >= 6 || 'Senha deve ter no mínimo 6 caracteres'
                  ]"
                  lazy-rules
                  :error="!!errors.password"
                  :error-message="errors.password"
                >
                  <template v-slot:prepend>
                    <q-icon name="lock" />
                  </template>
                  <template v-slot:append>
                    <q-icon
                      :name="showPassword ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="showPassword = !showPassword"
                    />
                  </template>
                </q-input>

                <!-- Lembrar-me e Esqueci senha -->
                <div class="row items-center justify-between">
                  <q-checkbox v-model="rememberMe" label="Lembrar-me" />
                  <q-btn
                    flat
                    dense
                    color="primary"
                    label="Esqueceu a senha?"
                    @click="handleForgotPassword"
                    class="text-caption"
                  />
                </div>

                <!-- Botão Submit -->
                <q-btn
                  type="submit"
                  color="primary"
                  label="Entrar"
                  :loading="loading"
                  unelevated
                  size="lg"
                  class="full-width q-mt-md"
                  icon-right="arrow_forward"
                />
              </q-form>
            </q-card-section>

            <!-- Divider -->
            <q-separator class="q-my-md" />

            <!-- Registro -->
            <q-card-section class="text-center">
              <p class="text-grey-7 q-mb-none">
                Não tem uma conta?
                <q-btn
                  flat
                  dense
                  color="primary"
                  label="Criar conta"
                  @click="handleRegister"
                  class="text-weight-bold"
                />
              </p>
            </q-card-section>
          </q-card>

          <!-- Footer -->
          <div class="text-center q-mt-md">
            <p class="text-grey-6 text-caption">
              © {{ new Date().getFullYear() }} Plataforma Imobiliária. Um produto da <a href="https://marrar.co.mz" target="__blank" style="text-decoration: none;">Marrar, LDA</a>.
            </p>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script setup>
import { ref } from 'vue'
import { useQuasar } from 'quasar'
import router from '@/router'
import store from '@/vuex/store'
import Swal from 'sweetalert2'

// eslint-disable-next-line no-unused-vars
const $q = useQuasar()

const form = ref({
  email: '',
  password: ''
})

const errors = ref({
  email: '',
  password: ''
})

const showPassword = ref(false)
const rememberMe = ref(false)
const loading = ref(false)

const handleLogin = async () => {
  loading.value = true
  errors.value = { email: '', password: '' }

  try {
   
    const res = await store.dispatch('auth/login', {
      email: form.value.email,
      password: form.value.password
    })
    console.log(res.access_token)
    sessionStorage.setItem('token', res.access_token)
    // console.log('Login bem-sucedido:', store.state.auth.user)
    
      router.push('/imoveis')
    
    
  } catch (error) {
    // console.error('Erro no login:', error)
    Swal.fire({
      icon: 'warning',
      title: 'Erro no login',
      text: 'Credenciais inválidas. Por favor, tente novamente.'
    })
    
    
  } finally {
    loading.value = false
  }
}

const handleForgotPassword = () => {
  router.push({ name: 'ResetPassword' })
  // router.push('/forgot-password')
}

const handleRegister = () => {
  
  router.push({  name: 'AutoRegister' })
}
</script>

<style scoped>
.bg-gradient {
  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 50%, #e8eaf6 100%);
  min-height: 100vh;
}

.login-container {
  width: 100%;
  max-width: 450px;
  padding: 20px;
}

.login-card {
  border-radius: 16px;
  border: 1px solid #e0e0e0;
}

.shadow-10 {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

@media (max-width: 600px) {
  .login-container {
    max-width: 100%;
  }
}
</style>